import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface TransactionListActionsHeaderProps
  extends HeaderContext<TransactionModel, unknown> {}

export const TransactionListActionsHeader =
  (): // props: TransactionListActionsHeaderProps,
  ReactNode => {
    // RENDER ////////////////////////////////////////////////////////////////////

    return null;
  };
